import { useState, useEffect } from "react";
import {Menu, X, Phone, ChevronDown} from 'lucide-react';

const navLinks = [
{ label: "Início", href: "#inicio" },
{ label: "A Empresa", href: "#empresa" },
{ label: "Produtos", href: "#produtos" },
{ label: "Serviços", href: "#servicos" },
{ label: "Catálogo", href: "#catalogo" },
{ label: "Contato", href: "#contato" }];


export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* Top bar */}
      <div className="bg-[#F5A623] text-[#0D1B3E] text-xs font-bold py-2 px-6 hidden md:flex items-center justify-between tracking-wide">
        <span className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#0D1B3E]/40" />
          CPO São Cristóvão, 388 – Rio de Janeiro · CEP 20.921-440
        </span>
        <a
          href="mailto:suporte@manguenela.com.br"
          className="hover:underline underline-offset-2 flex items-center gap-1.5">

          ✉ suporte@manguenela.com.br
        </a>
      </div>

      {/* Main navbar */}
      <nav
        className={`sticky top-0 z-50 w-full transition-all duration-400 ${
        scrolled ?
        "bg-[#0D1B3E]/95 backdrop-blur-md shadow-[0_4px_32px_-8px_rgba(0,0,0,0.5)] border-b border-white/5" :
        "bg-[#0D1B3E]"}`
        }>

        <div className="px-5 md:px-10 flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <a
            href="#inicio"
            onClick={(e) => {e.preventDefault();handleNav("#inicio");}}
            className="flex items-center group">

            <img
              src="https://static.lumi.new/43/43ff0b69169020285ea7cce93ddc1584.webp"
              alt="Manguenela Rio"
              className="h-16 md:h-20 w-auto drop-shadow-2xl group-hover:scale-105 transition-transform duration-300 object-cover"></img>

          </a>

          {/* Desktop links */}
          <ul className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) =>
            <li key={link.href}>
                <button
                onClick={() => handleNav(link.href)}
                className="relative text-gray-300 hover:text-white font-semibold text-sm uppercase tracking-wider px-4 py-2 rounded-lg transition-all duration-200 hover:bg-white/5 group whitespace-nowrap">

                  {link.label}
                  <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-0 group-hover:w-4 h-0.5 bg-[#F5A623] rounded-full transition-all duration-300" />
                </button>
              </li>
            )}
          </ul>

          {/* CTA desktop */}
          <a
            href="https://wa.me/5521973516085?text=Olá! Gostaria de mais informações sobre os produtos da Manguenela Rio."
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center gap-2 bg-[#F5A623] hover:bg-[#ffc048] text-[#0D1B3E] font-black px-6 py-3 rounded-xl text-sm uppercase tracking-widest transition-all duration-200 shadow-lg shadow-[#F5A623]/20 hover:shadow-[#F5A623]/40 hover:-translate-y-0.5">

            <Phone size={15} />
            Solicitar Orçamento
          </a>

          {/* Mobile toggle */}
          <button
            className="lg:hidden text-white p-2 hover:bg-white/10 rounded-lg transition-colors"
            onClick={() => setOpen(!open)}
            aria-label="Menu">

            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open &&
        <div className="lg:hidden bg-[#08112b] border-t border-[#F5A623]/20 px-5 pb-7 pt-5">
            <ul className="flex flex-col gap-1 mb-5">
              {navLinks.map((link) =>
            <li key={link.href}>
                  <button
                onClick={() => handleNav(link.href)}
                className="w-full text-left text-gray-200 hover:text-[#F5A623] hover:bg-white/5 font-semibold text-sm uppercase tracking-wider py-3 px-3 rounded-lg transition-all">

                    {link.label}
                  </button>
                </li>
            )}
            </ul>
            <a
            href="https://wa.me/5521973516085?text=Olá! Gostaria de mais informações."
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-[#F5A623] text-[#0D1B3E] font-black px-5 py-3.5 rounded-xl text-sm uppercase tracking-wider shadow-lg shadow-[#F5A623]/20">

              <Phone size={16} />
              Solicitar Orçamento
            </a>
          </div>
        }
      </nav>
    </>);

}